import React from 'react';
import { X, MessageCircle, AtSign } from 'lucide-react';
import { usePopupNotifications } from '../../hooks/usePopupNotifications';
import './PopupNotifications.css';

export const PopupNotifications: React.FC = () => {
  const { notifications, dismissNotification } = usePopupNotifications();

  if (notifications.length === 0) return null;

  return (
    <div className="popup-notifications">
      {notifications.map((notification) => (
        <div 
          key={notification.id}
          className={`popup-notification ${notification.type === 'mention' ? 'mention' : 'message'}`}
        >
          <div className="notification-icon">
            {notification.type === 'mention' ? (
              <AtSign className="w-4 h-4" />
            ) : (
              <MessageCircle className="w-4 h-4" />
            )}
          </div>
          
          <div className="notification-content">
            <div className="notification-header">
              <span className="sender-name">{notification.senderName}</span>
              <span className="timestamp">
                {notification.timestamp.toLocaleTimeString([], { 
                  hour: '2-digit', 
                  minute: '2-digit' 
                })}
              </span>
            </div>
            <div className="notification-message">
              {notification.message.length > 60 
                ? `${notification.message.substring(0, 60)}...` 
                : notification.message
              }
            </div>
          </div>
          
          <button
            className="dismiss-btn"
            onClick={() => dismissNotification(notification.id)}
            title="Dispensar notificação"
          >
            <X className="w-3 h-3" />
          </button>
        </div>
      ))}
    </div>
  );
};

export default PopupNotifications;